import Utils from "./Utils";

declare const jq: JQueryStatic;

export default class LayoutUtils extends Utils {

    public configureJqueryAjax(): void {
        if (typeof jq !== "undefined") {
            this.configureJqueryAjaxForInstance(jq);
        }
        if (typeof $ !== "undefined") {
            this.configureJqueryAjaxForInstance($);
        }
    }
}
